import React, { useContext } from 'react';
import Currency from '@prisjakt/ui-currency';
import { AppContext } from '@prisjakt/ui-app-context';

import * as S from './styles';

type OwnProps = {
  ariaLabel: string;
  handleOnChange: () => void;
  id: Number | String;
  image?: React.ReactNode;
  name: string;
  order?: number;
  price?: number | null;
  selected: boolean;
  title: string;
};

const VariantRadioButton = ({
  ariaLabel,
  handleOnChange,
  id,
  image,
  name,
  order,
  price,
  selected,
  title,
}: OwnProps) => {
  const { t } = useContext(AppContext);

  return (
    <S.Label
      htmlFor={`radio-${id}`}
      selected={selected}
      onChange={handleOnChange}
      aria-label={ariaLabel}
      order={order}
    >
      <S.Wrapper>
        {image}
        <S.TextWrapper>
          <S.Input type="radio" name={name} id={`radio-${id}`} />

          <S.Title>{title}</S.Title>
          <S.Subtitle>
            {t('product', 'price.from')}{' '}
            {price ? <Currency price={price} /> : '-'}
          </S.Subtitle>
        </S.TextWrapper>
      </S.Wrapper>
    </S.Label>
  );
};

export default VariantRadioButton;
